export enum SYMBOL_POSITION {
	PREFIXED,
	POSTFIXED,
}

export type SymbolPosition = SYMBOL_POSITION;
